import React from "react";
import css from "./style.scss";
import moment from "moment";
import { NumberBox } from "components/account_page/stats/sections/utils";
import WarningIcon from "react-icons/lib/md/warning";
import { n } from "shared/numbers";
import Date from "./date";

const infoLabels = {
  taps_back: "Taps Back",
  taps_forward: "Taps Forward",
  replies: "Replies",
  reach: "Reach",
  impressions: "Impressions",
  exits: "Exits",
};
const InfoRow = (props) => {
  return (
    <NumberBox
      percentage={props.reach ? (props.value * 100) / props.reach : -1}
      className={css.info_box}
      title={infoLabels[props.label]}
    >
      {props.value === -1 ? "-" : n(props.value)}
    </NumberBox>
  );
};

const ErrorNotes = (props) => (
  <div className={css.errorNotes}>
    {props.error === "TOO_SOON" && (
      <p>
        We can't display the insights of this story because it was created{" "}
        <b>before</b> this Instagram account was converted to Business.
      </p>
    )}
    {props.error === "API_ERROR" && (
      <p>
        There are some problems with Instagram. We will try to get the latest
        insights as soon as possible.
      </p>
    )}
    <WarningIcon size={32} />
  </div>
);
const Sidebar = (props) => {
  return (
    <div className={css.sidebar}>
      <Date date={props.posted_at} />
      <h3>Stats</h3>
      {props.sync.error && <ErrorNotes error={props.sync.error} />}
      <p className={css.tip}>
        Starting January 3rd 2024, Facebook deprecated Exits, Taps Forward and
        Taps Back values. For this reason, Stori can't obtain those values
        anymore.
      </p>

      <div className={css.info_container}>
        <InfoRow
          key="impressions"
          label="impressions"
          value={props.insights.impressions}
        />
        <InfoRow key="reach" label="reach" value={props.insights.reach} />
        <InfoRow
          key="replies"
          label="replies"
          value={props.insights.replies}
          reach={props.insights.reach}
        />
        <InfoRow
          key="exits"
          label="exits"
          value={props.insights.exits}
          reach={props.insights.reach}
        />
        <InfoRow
          key="taps_forward"
          label="taps_forward"
          value={props.insights.taps_forward}
          reach={props.insights.reach}
        />
        <InfoRow
          key="taps_back"
          label="taps_back"
          value={props.insights.taps_back}
          reach={props.insights.reach}
        />
      </div>
      <p className={css.tip}>
        All percentage are calculated on the story's reach.
      </p>
      <p className={css.tip}>Last Sync: {moment(props.sync.last).fromNow()}</p>
    </div>
  );
};

export default Sidebar;



// WEBPACK FOOTER //
// ./src/components/account_page/story_details/sidebar/index.js